import src from "IMAGE";
export default { src, width: 2124, height: 341, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAHUlEQVR42mMo1n/8WYHLNYOBgcENip2B2AVKmwMAccAE3Y8JHCkAAAAASUVORK5CYII="};
